// start:ng42.barrel
import   './task-editor.component';
import   './task-list.component';
// end:ng42.barrel

